import { createEmptyCart, getProducts, addProductToCart } from './_graphql';
import { getMindboxPrices, type LandingPriceInfo } from './_mindbox';

const $productNotification = document.querySelector('[data-role=notification]') as HTMLDivElement;
const $productName = $productNotification.querySelector('[data-role=product-name]');
const $productImage = $productNotification.querySelector('[data-role=product-image]') as HTMLImageElement;
const $productPricePopup = $productNotification.querySelector('[data-role=regular-price]');
const $productBasePricePopup = $productNotification.querySelector('[data-role=old-price]');
const $cartQty = document.querySelector('[data-role=cart-counter]');
const cart: Record<string, number> = {};
const $closeButton = document.querySelectorAll('[data-role=close-button]');

const skus = ['28709AG', '28738A', '28694W', '28692B'];
let pricesCache: Record<string, LandingPriceInfo> = {};

const getProductPrices = async () => {
    const products = await getProducts(skus);
    const prices = await getMindboxPrices(products);

    pricesCache = prices;

    products.forEach(product => {
        const priceInfo = prices[product.sku];
        const $productPrice = document.querySelector(`[data-role=product-price-${product.sku}]`);
        const $productBasePrice = document.querySelector(`[data-role=product-base-price-${product.sku}]`);
        const $productButton = document.querySelector(`[data-role=product-button-${product.sku}]`);

        if (priceInfo) {
            const finalPrice = priceInfo.finalPrice ?? priceInfo.basePrice;
            const regularPrice = priceInfo.basePrice;

            if (typeof $productPrice?.textContent === 'string') {
                $productPrice.textContent = `${finalPrice} ₽`;
            }

            if (regularPrice > finalPrice && typeof $productBasePrice?.textContent === 'string') {
                $productBasePrice.textContent = `${regularPrice} ₽`;
            }
        }

        if (product.stock_status === 'IN_STOCK') {
            $productButton?.classList?.add('available');
        }
    });
};

document.addEventListener('submit', async (event) => {
    event.preventDefault();

    const $form = event.target as HTMLFormElement;

    if ($form.dataset.role !== 'add-to-cart-form') {
        return;
    }

    const formData = new FormData($form);
    const sku = formData.get('id') as string | null;

    if (!sku) {
        return;
    }

    let cartId = document.cookie.match(/(?:^|\s*)cart_id=([^;]*)/)?.[1];

    if (!cartId) {
        cartId = await createEmptyCart();
        document.cookie = `cart_id=${cartId}; path=/; domain=${window.location.hostname}; SameSite=Lax; Secure`;
    }

    const quantity = cart[sku] ? cart[sku] + 1 : 1;
    const result = await addProductToCart(cartId, sku, quantity);

    if (!result?.addSimpleProductsToCart?.cart) {
        return;
    }

    cart[sku] = quantity;

    const cartItem = result.addSimpleProductsToCart.cart.items.find(item => item.product.sku === sku);
    
    if (cartItem) {
        const { product } = cartItem;
        const basketCount = Object.values(cart).reduce((sum, current) => sum + current, 0);
        const priceInfo = pricesCache[sku];
        const finalPrice = priceInfo?.finalPrice ?? priceInfo?.basePrice;
        const regularPrice = priceInfo?.basePrice;

        if (typeof $productName?.textContent === 'string') {
            $productName.textContent = product.name;
        }

        if (typeof $productImage?.src === 'string' && product.image?.url) {
            $productImage.src = product.image.url;
        }

        if (typeof $productPricePopup?.textContent === 'string' && finalPrice) {
            $productPricePopup.textContent = `${finalPrice} ₽`;
        }

        if (typeof $productBasePricePopup?.textContent === 'string' && regularPrice && finalPrice && regularPrice > finalPrice) {
            $productBasePricePopup.textContent = `${regularPrice} ₽`;
        }

        if (basketCount && typeof $cartQty?.textContent === 'string') {
            $cartQty.textContent = String(basketCount);
        }

        $productNotification.classList.add('_show');
    }
});

if ($closeButton) {
    $closeButton.forEach(($el) => {
        $el.addEventListener('click', () => $productNotification.classList.remove('_show'));
    });
}

getProductPrices();
